import { Link, useLocation } from 'react-router-dom'
import { LoginBox, LoginInfo, LoginRegisterLinks, Logo } from "./styles"
import KlutchLogo from 'assets/images/klutch-logo.svg'
import { SocialLoginPasswordComponent } from './components/SocialLoginPasswordComponent'
import { connect } from 'react-redux'
import { doLogin_action } from 'store/actions'


const SocialLoginPassword = ({doLogin}) => {
  const { search } = useLocation()

  return (
    <LoginBox className='app-box'>
      <LoginInfo>
        <Logo>
          <img src={KlutchLogo} alt='Klutch - Canned Responses logo' />
        </Logo>
        <SocialLoginPasswordComponent doLogin={doLogin}/>
      </LoginInfo>
      <LoginRegisterLinks>
        Don't have your Team? <Link to={`/register${search}`}>Sign Up</Link>
      </LoginRegisterLinks>
    </LoginBox>
  )
}

const mapDispatchToProps = (dispatch) => ({
  doLogin: (data) => new Promise((resolve, reject) => dispatch(doLogin_action(data, resolve, reject)))
})

export default connect(null, mapDispatchToProps)(SocialLoginPassword)